import React, { useState, useRef, useEffect } from 'react';
import './AppNavigationButton.css';

const AppNavigationButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Get the base domain for constructing URLs
  const getBaseDomain = () => {
    const hostname = window.location.hostname;

    // Handle different environments
    if (hostname === 'localhost') {
      return 'localhost'; // Local development
    } else if (hostname.includes('motivation-inc.com')) {
      // Extract branch from subdomain if present
      const parts = hostname.split('.');
      if (parts.length > 3) {
        // Branch deployment: docreview.s3lion.branch-name.motivation-inc.com
        const branchName = parts[2];
        return `${branchName}.motivation-inc.com`;
      } else {
        // Production: docreview.s3lion.motivation-inc.com
        return 'motivation-inc.com';
      }
    }
    return hostname;
  };

  const baseDomain = getBaseDomain();
  const isLocalhost = baseDomain === 'localhost';

  const apps = [
    {
      name: 'S3 Lion',
      description: 'Section 3 Compliance Management',
      url: isLocalhost ? 'http://localhost:8081' : `https://s3lion.${baseDomain}`,
      icon: <img src="/lion-favicon.ico" alt="S3 Lion" style={{ width: '40px', height: '40px' }} />,
      color: '#1976d2'
    },
    {
      name: 'Cub',
      description: 'Section 3 Reporting Tool',
      url: isLocalhost ? 'http://localhost:8082' : `https://cub.s3lion.${baseDomain}`,
      icon: <img src="/cub-favicon.ico" alt="Cub" style={{ width: '40px', height: '40px' }} />,
      color: '#ff9800'
    },
    {
      name: 'Document Review',
      description: 'Current Application',
      url: window.location.origin,
      icon: <img src="/favicon.ico" alt="Document Review" style={{ width: '40px', height: '40px' }} />,
      color: '#388e3c',
      current: true
    },
    {
      name: 'PHPMyAdmin',
      description: 'Database Management',
      url: isLocalhost ? 'http://localhost:8889' : `https://phpmyadmin.s3lion.${baseDomain}`,
      icon: <img src="/phpma-favicon.png" alt="Document Review" style={{ width: '40px', height: '40px' }} />,
      color: '#f57c00'
    },
    {
      name: 'Motivation Inc',
      description: 'Company Website',
      url: 'https://www.motivation-inc.com',
      icon: <img src="/minc-logo.png" alt="Motivation Inc" style={{ height: '20px', width: 'auto' }} />,
      color: '#2c3e50'
    }
  ];

  const handleAppClick = (app) => {
    if (!app.current) {
      window.open(app.url, '_blank', 'noopener,noreferrer');
    }
    setIsOpen(false);
  };

  return (
    <div className="app-nav-container" ref={dropdownRef}>
      <button
        className="app-nav-button"
        onClick={() => setIsOpen(!isOpen)}
        title="S3 Lion Applications"
        aria-label="Open application menu"
      >
        <div className="app-nav-grid">
          <div className="nav-dot"></div>
          <div className="nav-dot"></div>
          <div className="nav-dot"></div>
          <div className="nav-dot"></div>
          <div className="nav-dot"></div>
          <div className="nav-dot"></div>
          <div className="nav-dot"></div>
          <div className="nav-dot"></div>
          <div className="nav-dot"></div>
        </div>
      </button>

      {isOpen && (
        <div className="app-nav-dropdown">
          <div className="app-nav-header">
            <h3>S3 Lion Applications</h3>
          </div>
          <div className="app-nav-grid-container">
            {apps.map((app, index) => (
              <div
                key={index}
                className={`app-nav-item ${app.current ? 'current' : ''}`}
                onClick={() => handleAppClick(app)}
                style={{ '--app-color': app.color }}
              >
                <div className="app-icon" style={{ backgroundColor: app.color }}>
                  {typeof app.icon === 'string' ? app.icon : app.icon}
                </div>
                <div className="app-info">
                  <div className="app-name">{app.name}</div>
                  <div className="app-description">{app.description}</div>
                </div>
                {app.current && (
                  <div className="current-indicator">
                    <span>●</span>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="app-nav-footer">
            <small>Click to open application in new tab</small>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppNavigationButton;